import { FC, useState } from 'react';

import { AddDocumentIcon } from '../../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import { Tooltip } from '../../../../../components/tooltip/index';
import { EventHooks, useFormat } from '../../../../../hooks/index';
import { downloadDocumentStorage } from '../../../../../storage/modals/index';
import { EventTypeBackend, ExerciseEventItem } from '../../../../../types/events.types';
import { getS3FileOriginalName } from '../../../../../utils/get-s3file-original-name.util';
import { BasicTable } from './basic-table';
import {
  getTransactionsTableStateProps,
  itemsToFetchMap,
  TableBodyProps,
} from './event-table-types.types';
import { PaginationItem } from './pagination-item';
import { EventSignatureStatusTableCell, Td } from './table-td';

export const Expire: FC<TableBodyProps> = (props) => {
  const { format } = useFormat();

  const openDownloadDocumentModal = downloadDocumentStorage(({ open }) => open);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsToFetch, setItemsToFetch] = useState(itemsToFetchMap[0]);

  const { items, totalPages, isLoading } = EventHooks.useTransactions<ExerciseEventItem>({
    eventId: props.eventId,
    eventType: EventTypeBackend.EXPIRE,
    companyId: props.companyId,
    currentPage,
    take: Number(itemsToFetch),
    dateFilter: props.selectedDateFilter,
    customDateFilter: props.selectedCustomDateFilter,
    transactionView: props.transactionView,
  });

  const tableStateProps = getTransactionsTableStateProps({
    selectedDateFilter: props.selectedDateFilter,
    selectedCustomDateFilter: props.selectedCustomDateFilter,
    transactionView: props.transactionView,
    isLoading,
    itemsCount: items.length,
    event: props,
    itemsToFetch: Number(itemsToFetch),
  });

  if (props.type !== EventTypeBackend.EXPIRE) return <></>;

  return (
    <>
      <BasicTable
        eventType={EventTypeBackend.EXPIRE}
        transactionView={props.transactionView}
        {...tableStateProps}
      >
        {items.map(
          ({
            id,
            exercised,
            vestingTask,
            date,
            signatureSignedCount,
            signatureStatus,
            signatureTotalCount,
            exerciseEvent: {
              event: { filesLinks },
            },
          }) => {
            return (
              <tr key={id}>
                <Td value={format(date, 'dd/MM/yyyy')} />
                <Td value={<AppFormattedMessage id={'EXPIRE_WARRANTS'} />} />
                <Td
                  value={
                    <Tooltip content={vestingTask.grantItem.stakeholder.fullName}>
                      <span>{vestingTask.grantItem.stakeholder.fullName}</span>
                    </Tooltip>
                  }
                />
                <Td className="uppercase" value={id.split('-')[0]} />
                <Td value={exercised.toLocaleString('en-US')} />
                <Td value={vestingTask.grantItem.plan.pool.shareClass.name} />
                <Td value={format(vestingTask.grantItem.plan.expiryDate, 'dd/MM/yyyy')} />
                <EventSignatureStatusTableCell
                  signatureSignedCount={
                    signatureSignedCount ?? props.signatureSummary?.signatureSignedCount
                  }
                  signatureStatus={signatureStatus ?? props.signatureSummary?.signatureStatus}
                  signatureTotalCount={
                    signatureTotalCount ?? props.signatureSummary?.signatureTotalCount
                  }
                />
                {!props.transactionView && (
                  <Td
                    value={
                      <Tooltip
                        content={
                          <span className="block w-full truncate p-0 text-label-md font-[550] text-white">
                            {filesLinks.length === 1
                              ? getS3FileOriginalName(filesLinks[0])
                              : `${filesLinks.length} files attached to event`}
                          </span>
                        }
                      >
                        <AddDocumentIcon
                          className="size-6 cursor-pointer p-[2px]"
                          onClick={() => openDownloadDocumentModal(filesLinks)}
                        />
                      </Tooltip>
                    }
                  />
                )}
              </tr>
            );
          },
        )}
      </BasicTable>
      <PaginationItem
        currentPage={currentPage}
        handleChangeCurrentPage={setCurrentPage}
        handleFetchAmountChange={setItemsToFetch}
        itemsCount={items.length}
        itemsToFetch={itemsToFetch}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />
    </>
  );
};
